import FunnelSpec from './chartSpec';
import FunnelPlot from './plot';
import FunnelChart from './chart';

export default FunnelChart;
export { FunnelSpec, FunnelPlot };
